<template>
  <div class>
    <div slot="header" class="clearfix">
      <span style="font-weight:600;color:#000; line-height: 30px;">充电温度告警</span>
      <el-button type="primary" plain style="float:right" @click="reviseChargingTemperatureAlarm">修改</el-button>
    </div>
    <el-input
      v-model="form.chargingTemperatureAlarm"
      type="textarea"
      :rows="6"
      placeholder="请输入告警模板"
      :disabled="isChargingTemperatureAlarm"
      class="input"
    />
    <div slot="header" class="clearfix">
      <span style="font-weight:600;color:#000; line-height: 30px;">充电电压告警</span>
      <el-button type="primary" plain style="float:right" @click="reviseChargingVoltageAlarm">修改</el-button>
    </div>
    <el-input
      v-model="form.chargingVoltageAlarm"
      type="textarea"
      :rows="6"
      placeholder="请输入告警模板"
      :disabled="isChargingVoltageAlarm"
      class="input"
    />
    <div slot="header" class="clearfix">
      <span style="font-weight:600;color:#000; line-height: 30px;">充电电流告警</span>
      <el-button type="primary" plain style="float:right" @click="reviseChargingCurrentAlarm">修改</el-button>
    </div>
    <el-input
      v-model="form.chargingCurrentAlarm"
      type="textarea"
      :rows="6"
      placeholder="请输入告警模板"
      :disabled="isChargingCurrentAlarm"
      class="input"
    />
    <div slot="header" class="clearfix">
      <span style="font-weight:600;color:#000; line-height: 30px;">输出功率不足告警</span>
      <el-button type="primary" plain style="float:right" @click="reviseChargingPowerAlarm">修改</el-button>
    </div>
    <el-input
      v-model="form.chargingPowerAlarm"
      type="textarea"
      :rows="6"
      placeholder="请输入告警模板"
      :disabled="isChargingPowerAlarm"
      class="input"
    />
    <div slot="header" class="clearfix">
      <span style="font-weight:600;color:#000; line-height: 30px;">电桩离线告警</span>
      <el-button type="primary" plain style="float:right" @click="reviseChargingOffLineAlarm">修改</el-button>
    </div>
    <el-input
      v-model="form.chargingOffLineAlarm"
      type="textarea"
      :rows="6"
      placeholder="请输入告警模板"
      :disabled="isChargingOffLineAlarm"
      class="input"
    />
    <div slot="header" class="clearfix">
      <span style="font-weight:600;color:#000; line-height: 30px;">电桩故障告警</span>
      <el-button type="primary" plain style="float:right" @click="reviseChargingFaultAlarm">修改</el-button>
    </div>
    <el-input
      v-model="form.chargingFaultAlarm"
      type="textarea"
      :rows="6"
      placeholder="请输入告警模板"
      :disabled="isChargingFaultAlarm"
      class="input"
    />
    <div slot="header" class="clearfix">
      <span style="font-weight:600;color:#000; line-height: 30px;">电池电量监控告警</span>
      <el-button type="primary" plain style="float:right" @click="reviseChargingBatteryAlarm">修改</el-button>
    </div>
    <el-input
      v-model="form.chargingBatteryAlarm"
      type="textarea"
      :rows="6"
      placeholder="请输入告警模板"
      :disabled="isChargingBatteryAlarm"
      class="input"
    />
    <div slot="header" class="clearfix">
      <span style="font-weight:600;color:#000; line-height: 30px;">SOC过充告警</span>
      <el-button type="primary" plain style="float:right" @click="reviseOverChargeAlarm">修改</el-button>
    </div>
    <el-input
      v-model="form.overChargeAlarm"
      type="textarea"
      :rows="6"
      placeholder="请输入告警模板"
      :disabled="isOverChargeAlarm"
      class="input"
    />
    <div slot="header" class="clearfix">
      <span style="font-weight:600;color:#000; line-height: 30px;">电池温度监控告警</span>
      <el-button type="primary" plain style="float:right" @click="reviseBatteryTemperatureMonitoringAlarm">修改</el-button>
    </div>
    <el-input
      v-model="form.batteryTemperatureMonitoringAlarm"
      type="textarea"
      :rows="6"
      placeholder="请输入告警模板"
      :disabled="isBatteryTemperatureMonitoringAlarm"
      class="input"
    />
    <div slot="header" class="clearfix">
      <span style="font-weight:600;color:#000; line-height: 30px;">用户账户负值告警</span>
      <el-button type="primary" plain style="float:right" @click="reviseUseAccountNegativeValueAlarm">修改</el-button>
    </div>
    <el-input
      v-model="form.useAccountNegativeValueAlarm"
      type="textarea"
      :rows="6"
      placeholder="请输入告警模板"
      :disabled="isUseAccountNegativeValueAlarm"
      class="input"
    />
    <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
      <el-button permission="notice.message.preservation" @click="cancel">取消</el-button>
      <el-button type="primary" permission="notice.message.preservation" @click="save">保存</el-button>
    </div>
  </div>
</template>
<script>
import { HOST, EV_HOST } from '@/utils/host'
const token = window.localStorage.getItem('token')
export default {
  name: 'SmsSettings',
  components: {},
  data() {
    return {
      form: {
        chargingTemperatureAlarm: '',
        chargingVoltageAlarm: '',
        chargingCurrentAlarm: '',
        chargingPowerAlarm: '',
        chargingOffLineAlarm: '',
        chargingFaultAlarm: '',
        chargingBatteryAlarm: '',
        overChargeAlarm: '',
        batteryTemperatureMonitoringAlarm: '',
        useAccountNegativeValueAlarm: ''
      },
      isChargingTemperatureAlarm: true,
      isChargingVoltageAlarm: true,
      isChargingCurrentAlarm: true,
      isChargingPowerAlarm: true,
      isChargingOffLineAlarm: true,
      isChargingFaultAlarm: true,
      isChargingBatteryAlarm: true,
      isOverChargeAlarm: true,
      isBatteryTemperatureMonitoringAlarm: true,
      isUseAccountNegativeValueAlarm: true
    }
  },
  computed: {
    headers() {
      return {
        token: token
      }
    }
  },
  mounted() {
    this.getList()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {

    reviseChargingTemperatureAlarm() {
      this.isChargingTemperatureAlarm = false
    },

    reviseChargingVoltageAlarm() {
      this.isChargingVoltageAlarm = false
    },

    reviseChargingCurrentAlarm() {
      this.isChargingCurrentAlarm = false
    },

    reviseChargingPowerAlarm() {
      this.isChargingPowerAlarm = false
    },

    reviseChargingOffLineAlarm() {
      this.isChargingOffLineAlarm = false
    },

    reviseChargingFaultAlarm() {
      this.isChargingFaultAlarm = false
    },

    reviseChargingBatteryAlarm() {
      this.isChargingBatteryAlarm = false
    },

    reviseOverChargeAlarm() {
      this.isOverChargeAlarm = false
    },

    reviseBatteryTemperatureMonitoringAlarm() {
      this.isBatteryTemperatureMonitoringAlarm = false
    },

    reviseUseAccountNegativeValueAlarm() {
      this.isUseAccountNegativeValueAlarm = false
    },
    cancel(){
      this.form = {
        chargingTemperatureAlarm: '',
        chargingVoltageAlarm: '',
        chargingCurrentAlarm: '',
        chargingPowerAlarm: '',
        chargingOffLineAlarm: '',
        chargingFaultAlarm: '',
        chargingBatteryAlarm: '',
        overChargeAlarm: '',
        batteryTemperatureMonitoringAlarm: '',
        useAccountNegativeValueAlarm: ''
      };
      this.isChargingTemperatureAlarm = true
      this.isChargingVoltageAlarm = true
      this.isChargingCurrentAlarm = true
      this.isChargingPowerAlarm = true
      this.isChargingOffLineAlarm = true
      this.isChargingFaultAlarm = true
      this.isChargingBatteryAlarm = true
      this.isOverChargeAlarm = true
      this.isBatteryTemperatureMonitoringAlarm = true
      this.isUseAccountNegativeValueAlarm = true
      this.getList()
    },

    save() {
      this.$store.dispatch('form/handle', {
        url: '/business/smsTemplate/post',
        data: this.form,
        method: 'post',
        callback: resp => {
          this.isChargingTemperatureAlarm = true
          this.isChargingVoltageAlarm = true
          this.isChargingCurrentAlarm = true
          this.isChargingPowerAlarm = true
          this.isChargingOffLineAlarm = true
          this.isChargingFaultAlarm = true
          this.isChargingBatteryAlarm = true
          this.isOverChargeAlarm = true
          this.isBatteryTemperatureMonitoringAlarm = true
          this.isUseAccountNegativeValueAlarm = true
        }
      })
    },

    getList() {
      this.$store.dispatch('form/handle', {
        url: '/business/smsTemplate/query',
        method: 'get',
        callback: resp => {
          console.log('tree', resp)
          this.form = resp
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
    .avatar-uploader /deep/ .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .clearfix {
        background-color:#F2F2F2;
        padding: 10px;
        margin-top: 15px;
        margin-bottom: 15px;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
    }

    .input {
        margin-left: 20px;
        width: 700px;
    }
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/smsSettings.vue